import i18next from "i18next"

export default function formatNumber(number : number) {
    return new Intl.NumberFormat(i18next.language).format(Math.round(number))
}

